import * as React from 'react';
import { Dispatch } from 'redux';
import { UploadedVideoViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventVideoNormalizers from '../normalizers/eventVideoNormalizers';

export class GetAllUploadedVideosRequest extends BaseApiGetRequest<
  UploadedVideoViewModel,
  EntityNormalizers.NormalizedEntityArray<UploadedVideoViewModel[]>
> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/events/${eventId}/uploaded-videos`;
    this.normalizeMethod = EventVideoNormalizers.normalizeUploadedVideosArray;
  }
}
